import { InstrumentType } from "@orb-labs/types";
import { ListStandardizedInstrumentsByCategoryQuery } from "../graphql/queries.js";
const PREDICTION_DISCOVERY_CATEGORIES = new Set(["notable", "newest"]);
const DEFAULT_CATEGORY_PAGE_SIZE = 20;
function forEachCachedPredictionCategoryQuery(apolloClient, visit) {
    const rootFields = apolloClient.cache.inspectFields("ROOT_QUERY");
    for (const field of rootFields) {
        if (field.fieldName !== "listStandardizedInstrumentsByCategory" || !field.arguments)
            continue;
        const categoryFilter = field.arguments?.input?.categoriesFilters?.[0];
        if (categoryFilter?.type !== InstrumentType.PREDICTION_MARKET)
            continue;
        try {
            const existing = apolloClient.cache.readQuery({
                query: ListStandardizedInstrumentsByCategoryQuery,
                variables: field.arguments,
            });
            if (!existing)
                continue;
            visit(field.arguments, existing);
        }
        catch {
            continue;
        }
    }
}
export function prependToPredictionCategories(apolloClient, instrument) {
    forEachCachedPredictionCategoryQuery(apolloClient, (variables, existing) => {
        const categories = existing.listStandardizedInstrumentsByCategory?.standardizedPredictionsByCategory;
        if (!Array.isArray(categories) || categories.length === 0)
            return;
        let changed = false;
        const nextCategories = categories.map((category) => {
            const categoryName = category?.category;
            if (!categoryName || !PREDICTION_DISCOVERY_CATEGORIES.has(categoryName))
                return category;
            const existingEdges = category.edges ?? [];
            if (existingEdges.some((edge) => edge.standardizedInstrumentId === instrument.standardizedInstrumentId)) {
                return category;
            }
            changed = true;
            const pageSize = variables?.input?.categoriesFilters?.[0]?.limit;
            const maxEdges = typeof pageSize === "number" && pageSize > 0 ? pageSize : DEFAULT_CATEGORY_PAGE_SIZE;
            return {
                ...category,
                edges: [instrument, ...existingEdges].slice(0, maxEdges),
            };
        });
        if (!changed)
            return;
        apolloClient.cache.writeQuery({
            query: ListStandardizedInstrumentsByCategoryQuery,
            variables,
            data: {
                listStandardizedInstrumentsByCategory: {
                    ...existing.listStandardizedInstrumentsByCategory,
                    standardizedPredictionsByCategory: nextCategories,
                },
            },
        });
    });
}
export function removeFromPredictionCategories(apolloClient, standardizedInstrumentId) {
    forEachCachedPredictionCategoryQuery(apolloClient, (variables, existing) => {
        const categories = existing.listStandardizedInstrumentsByCategory?.standardizedPredictionsByCategory;
        if (!Array.isArray(categories) || categories.length === 0)
            return;
        let changed = false;
        const nextCategories = categories.map((category) => {
            const existingEdges = category.edges ?? [];
            const filteredEdges = existingEdges.filter((edge) => edge.standardizedInstrumentId !== standardizedInstrumentId);
            if (filteredEdges.length === existingEdges.length)
                return category;
            changed = true;
            return {
                ...category,
                edges: filteredEdges,
            };
        });
        if (!changed)
            return;
        apolloClient.cache.writeQuery({
            query: ListStandardizedInstrumentsByCategoryQuery,
            variables,
            data: {
                listStandardizedInstrumentsByCategory: {
                    ...existing.listStandardizedInstrumentsByCategory,
                    standardizedPredictionsByCategory: nextCategories,
                },
            },
        });
    });
}
